import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedLensPowerCalculator from "./SharedLensPowerCalculator";
const TITLE =
  "Calculatrice de puissance de lentille - Découvrez comment calculer la puissance de la lentille oculaire";
const DESCRIPTION =
  "Calculatrice de puissance de lentille - Découvrez comment calculer la puissance de la lentille oculaire. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "lens power calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/lenspower";
function Calculator() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La puissance optique d'une lentille exprime sa capacité à faire converger les rayons vers le centre optique principal. Le symbole de la puissance de la lentille est représenté par la lettre "P". La puissance de la lentille est inversement proportionnelle à la distance focale, ce qui signifie que plus la distance focale est grande, plus la puissance de la lentille est faible, et vice versa.
                  <br />
                  La puissance de la lentille peut être calculée en utilisant l'équation P=1/F, où F représente la distance focale. La valeur de P est positive pour les lentilles convergentes, tandis qu'elle est négative pour les lentilles divergentes."
                  <br />
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <SharedLensPowerCalculator />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
